









import {Component, Prop, Vue} from 'vue-property-decorator';
import ImageManager from '@/script/ImageManager';
import TextManager from '@/script/TextManager';
import {dynamicAddScript} from '@/script/common';

@Component
export default class Footer extends Vue {
  @Prop({ type: Boolean, default: false })
  private hideTwitter!: boolean;

  private logo: string = ImageManager.INSTANCE.get('Twitterロゴ')!;
  private copyRight: string = TextManager.INSTANCE.get('copy-right')!;
  private hashTag: string = TextManager.INSTANCE.get('twitter-hash-tag')!;
  private twitterMsg: string = TextManager.INSTANCE.get('twitter-text')!;

  private created() {
    dynamicAddScript('https://platform.twitter.com/widgets.js');
  }
}
